import { useEffect, useState } from "react";
import { fetchAssetBlobUrl } from "../lib/orders-api";

/**
 * Renders an authenticated asset image. Fetches via the dashboard token, then
 * displays it as an object URL. Falls back to a placeholder if loading fails
 * (e.g. asset not yet rendered).
 */
export default function AuthAsset({
  url,
  alt,
  placeholder = "—",
  className = "w-full object-cover",
  placeholderClassName = "flex aspect-square w-full items-center justify-center bg-muted text-xs text-muted-foreground",
}: {
  url: string;
  alt: string;
  placeholder?: string;
  className?: string;
  placeholderClassName?: string;
}) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoked: string | null = null;
    setError(false);
    setObjectUrl(null);
    fetchAssetBlobUrl(url)
      .then((u) => {
        revoked = u;
        setObjectUrl(u);
      })
      .catch(() => setError(true));
    return () => {
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [url]);

  if (error) {
    return <div className={placeholderClassName}>{placeholder}</div>;
  }
  if (!objectUrl) {
    return (
      <div className={`${placeholderClassName} animate-pulse`} aria-busy="true">
        …
      </div>
    );
  }
  return <img className={className} src={objectUrl} alt={alt} />;
}
